import dayjs from 'dayjs'

const config = {
  rowSelection: false,
  search: false,
  scroll: {
    y: 'calc(100vh - 510px)',
  },
  columns: [
    {
      title: '项目ID',
      dataIndex: 'id',
      render: 'projectIdRender',
      width: 200,
      fixed: 'left',
    },
    {
      title: '合同编号',
      dataIndex: 'contractCode',
      width: 180,
    },
    {
      title: '服务地址',
      dataIndex: 'projectName',
      width: 240,
      ellipsis: true,
    },
    {
      title: '面积',
      dataIndex: 'signedArea',
      width: 80,
      render: (text: string) => text + '㎡' || '-',
    },
    {
      title: '需求类型',
      dataIndex: 'customerTypeDesc',
      width: 120,
      render: 'demandTagRender',
    },
    {
      title: '产品',
      dataIndex: 'productName',
      width: 180,
      ellipsis: true,
    },
    {
      title: '门店',
      dataIndex: 'companyName',
      width: 150,
    },
    {
      title: '交付模式',
      dataIndex: 'deliveryModelName',
      width: 120,
      render: (text: string) => text || '-',
    },
    {
      title: '当前阶段',
      dataIndex: 'phaseName',
      width: 150,
      render: (text: string) => text || '-',
    },
    {
      title: '状态',
      dataIndex: 'projectStatusName',
      width: 120,
    },
    {
      title: '实际开工日期',
      dataIndex: 'actualStartDate',
      width: 120,
      render: (text: string) => (text ? dayjs(text).format('YYYY-MM-DD') : '-'),
    },
    {
      title: '工期',
      dataIndex: 'timeLimit',
      width: 120,
      render: 'timeLimitRender',
    },
    {
      title: '施工天数',
      dataIndex: 'constructionDay',
      width: 120,
      render: 'timeLimitRender',
    },
    {
      title: '项目进度',
      dataIndex: 'siteSchedule',
      width: 150,
      render: 'projectProgressRender',
    },
    {
      title: '计划完工时间',
      dataIndex: 'plannedEndDate',
      width: 120,
      render: (text: string) => (text ? dayjs(text).format('YYYY-MM-DD') : '-'),
    },
    {
      title: '实际完工时间',
      dataIndex: 'actualEndDate',
      width: 120,
      render: (text: string) => (text ? dayjs(text).format('YYYY-MM-DD') : '-'),
    },
  ],
  footer: false,
}

export default config
